import { useEffect, useRef } from 'react';
import { useIsMobile } from 'src/hooks/useIsMobile';
import animationMov from 'src/static/animations/explore/bot-avatar-halo.mp4';
import poster from 'src/static/animations/explore/bot-avatar-halo.png';
import animationWebm from 'src/static/animations/explore/bot-avatar-halo.webm';
import './BotHaloAnimation.sass';

const BotHaloAnimation = ({ play = false }: { play: boolean }) => {
	const ref = useRef<HTMLVideoElement>(null);
	const isMobile = useIsMobile();
	const posterSrc = `${window?._env_?.HOST_URL ?? ''}${poster}`;

	useEffect(() => {
		const video = ref?.current;
		if (isMobile || play) {
			video?.play();
		} else {
			video?.pause();
		}
		return () => {
			if (video) {
				video.currentTime = 0;
			}
		};
	}, [isMobile, play]);

	return (
		<video className="bot-halo-animation" disableRemotePlayback muted playsInline loop poster={posterSrc} ref={ref}>
			<source src={animationMov} type="video/mp4;codecs=hvc1" />
			<source src={animationWebm} type="video/webm" />
		</video>
	);
};

export default BotHaloAnimation;
